export default from './SavingsSituation';



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/SavingsSituation/index.js